import { Theme } from "theme-ui";

export const htmlElementStyles: Theme["styles"] = {
  root: {
    height: "100%",
    fontFamily: "body",
    fontWeight: "medium",
    fontStyle: "normal",
    fontSize: 1,
    backgroundColor: "white",
    color: "text",
    margin: 0,
    lineHeight: "body",
  },
  h1: {
    color: "text",
    fontFamily: "heading",
    lineHeight: "heading",
    fontWeight: "heading",
    fontSize: 5,
  },
  h2: {
    color: "text",
    fontFamily: "heading",
    lineHeight: "heading",
    fontWeight: "heading",
    fontSize: 4,
  },
  h3: {
    color: "text",
    fontFamily: "heading",
    lineHeight: "heading",
    fontWeight: "heading",
    fontSize: 3,
  },
  h4: {
    color: "text",
    fontFamily: "heading",
    lineHeight: "heading",
    fontWeight: "heading",
    fontSize: 2,
  },
  h5: {
    color: "text",
    fontFamily: "heading",
    lineHeight: "heading",
    fontWeight: "heading",
    fontSize: 1,
  },
  h6: {
    color: "text",
    fontFamily: "heading",
    lineHeight: "heading",
    fontWeight: "heading",
    fontSize: 0,
  },
  p: {
    color: "text",
    fontFamily: "body",
    fontWeight: "body",
    lineHeight: "body",
  },
  a: {
    color: "black",
    fontFamily: "body",
    fontWeight: "body",
    textDecoration: "underline",
    cursor: "pointer",
    transition: "color 125ms ease-in",
    "&:hover": {
      transition: "color 125ms ease-in",
      color: "primary",
    },
  },
  pre: {
    fontFamily: "monospace",
    overflowX: "auto",
    code: {
      color: "inherit",
    },
  },
  code: {
    fontFamily: "monospace",
    fontSize: "inherit",
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
  },
  th: {
    textAlign: "left",
    borderBottomStyle: "solid",
    minWidth: "100px",
  },
  td: {
    textAlign: "left",
    borderBottomStyle: "solid",
    borderBottomWidth: "1px",
    fontWeight: "body",
    pt: 2,
    pb: 2,
  },
  img: {
    maxWidth: "100%",
  },
};

export default htmlElementStyles;
